export const ALERT_TICKET_ACCEPT = {
  photo: [".jpg", ".jpeg", ".png", ".gif", ".webp", ".bmp", ".heic", ".heif"],
  kml: [".kml", ".kmz"],
  pdf: [".pdf"],
  archive: [".zip", ".rar"],
};

export const ALERT_TICKET_ACCEPT_ATTR = {
  kml: ".kml,.kmz",
  pdf: ".pdf",
  archive: ".zip,.rar",
  photo: "image/*",
};

export function hasAllowedExt(file, allowed) {
  const name = (file?.name || "").toLowerCase();
  return allowed.some((ext) => name.endsWith(ext));
}

export function validateFiles(files, allowed, label) {
  for (const f of files) {
    if (!f) continue;
    if (!hasAllowedExt(f, allowed)) {
      throw new Error(`Arquivo inválido em ${label}: ${f.name}`);
    }
  }
}

export function validateAlertTicketSubmission({
  photoRows = [],
  kmlFiles = [],
  pdfFiles = [],
  archiveFiles = [],
}) {
  const photos = photoRows.map((r) => r.file).filter(Boolean);
  validateFiles(photos, ALERT_TICKET_ACCEPT.photo, "fotos");
  validateFiles(kmlFiles, ALERT_TICKET_ACCEPT.kml, "KML/KMZ");
  validateFiles(pdfFiles, ALERT_TICKET_ACCEPT.pdf, "PDF");
  validateFiles(archiveFiles, ALERT_TICKET_ACCEPT.archive, "ZIP/RAR");
}

export function appendAlertTicketFiles(
  formData,
  { photoRows = [], kmlFiles = [], pdfFiles = [], archiveFiles = [] }
) {
  photoRows.forEach(({ file, processType }) => {
    if (file) {
      formData.append("photos", file);
      formData.append("photo_types", processType);
    }
  });

  kmlFiles.forEach((file) => {
    if (file) formData.append("kml_files", file);
  });
  pdfFiles.forEach((file) => {
    if (file) formData.append("pdf_files", file);
  });
  archiveFiles.forEach((file) => {
    if (file) formData.append("archive_files", file);
  });
}

export const ATTACHMENT_TYPE_LABELS = {
  kml: "KML / KMZ",
  pdf: "PDF",
  archive: "ZIP / RAR",
};

export const ATTACHMENT_TYPE_ICONS = {
  kml: "🗺️",
  pdf: "📄",
  archive: "📦",
};
